import i18n, { LanguageEnum } from "@/i18n";

export default function useRTL() {
  return i18n.language === LanguageEnum.AR;
}
